import { FC, useCallback } from 'react';
import { NotificationsSettingType, notificationsSettingLabelPostscript } from '../../constants/notifications';
import { INotificationSetting } from '../../types/notifications';
import { localeStore } from 'src/mobx/localesStore';
import { TBooleanInNumber } from 'src/types/main';
import { confirmDelete } from 'src/utils/modalConfirmations';
import Switcher from 'src/view/components/Controls/Switcher/Switcer';
import DeleteRestoreBlock from 'src/view/components/DeleteRestoreBlock/DeleteRestoreBlock';
import Text, { TEXT } from '~/view/components/Text/Text';
import './style.scss';

interface IProps {
  type: NotificationsSettingType;
  notification: INotificationSetting;
  onStatusChange: (id: number, status: TBooleanInNumber) => void;
  onDelete: (id: number) => void;
}

const NotificationsSettingListRow: FC<IProps> = ({ type, notification, onStatusChange, onDelete }: IProps): JSX.Element => {
  const onStatusChangeHandler = useCallback(
    (status: TBooleanInNumber) => {
      onStatusChange(notification.id, status);
    },
    [notification]
  );

  const onDeleteHandler = useCallback(() => {
    confirmDelete({
      title: localeStore.t('delete_notification_title'),
      message: localeStore.t('delete_notification_message'),
      onConfirm: () => onDelete(notification.id),
    });
  }, [notification]);

  return (
    <div className="notifications-setting-list-row notifications-setting-list-row__grid-template mr-4">
      {/* subject */}
      <div className="notifications-setting-list-row__element">
        <Text type={TEXT.LIST_ROW} text={notification.subject.en} noTranslate className="notifications-setting-list-row__text text-break" />
      </div>
      <div className="notifications-setting-list-row__element">
        <Text type={TEXT.LIST_ROW} text={notification.subject.ar} noTranslate className="notifications-setting-list-row__text text-break" />
      </div>

      {/* message */}
      <div className="notifications-setting-list-row__element">
        <Text type={TEXT.LIST_ROW} text={notification.message.en} noTranslate className="notifications-setting-list-row__message text-break" />
      </div>
      <div className="notifications-setting-list-row__element">
        <Text type={TEXT.LIST_ROW} text={notification.message.ar} noTranslate className="notifications-setting-list-row__message text-break" />
      </div>

      <div className="notifications-setting-list-row__element">
        <Text type={TEXT.LIST_ROW} text={notification.deliveryMethod} className="notifications-setting-list-row__text text-break" />
      </div>

      <div className="notifications-setting-list-row__element">
        <Text
          type={TEXT.LIST_ROW}
          text={notification.event + notificationsSettingLabelPostscript[type]}
          className="notifications-setting-list-row__text text-break"
        />
      </div>

      <div className="notifications-setting-list-row__element gap-20">
        <Switcher status={notification.status} onChange={onStatusChangeHandler} />
        <DeleteRestoreBlock onDelete={onDeleteHandler} />
      </div>
    </div>
  );
};

export default NotificationsSettingListRow;
